export const Config = {
  pagination: {
    pageSize: 8,
  },
  regionSelector: true,
};
